/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import { Iterable, pipe } from '@blade/std-lib'
import { reatomBigNumberComputed } from '@root/shared/lib'

import type { WalletPositionModel } from './reatom-wallet-position'
import type { Atom } from '@reatom/framework'

export const reatomAggregatedPositionSizes = ({
  walletPositionsAtom,
}: {
  walletPositionsAtom: Atom<Array<WalletPositionModel>>
}) => {
  const boughtSizeUsdAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const boughtSizeUsd = ctx.spy(position.boughtSizeUsd)
        return acc.plus(boughtSizeUsd)
      }),
    )
  })

  const boughtSizeNativeAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const boughtSizeNative = ctx.spy(position.boughtSizeNative)
        return acc.plus(boughtSizeNative)
      }),
    )
  })

  const boughtSizeCurrencyAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const boughtSizeCurrency = ctx.spy(position.boughtSizeCurrency)
        return acc.plus(boughtSizeCurrency)
      }),
    )
  })

  const boughtTransactionsAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const boughtTransactions = ctx.spy(position.boughtTransactions)
        return acc.plus(boughtTransactions)
      }),
    )
  })

  const soldSizeUsdAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const soldSizeUsd = ctx.spy(position.soldSizeUsd)
        return acc.plus(soldSizeUsd)
      }),
    )
  })

  const soldSizeNativeAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const soldSizeNative = ctx.spy(position.soldSizeNative)
        return acc.plus(soldSizeNative)
      }),
    )
  })

  const soldSizeCurrencyAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const soldSizeCurrency = ctx.spy(position.soldSizeCurrency)
        return acc.plus(soldSizeCurrency)
      }),
    )
  })

  const soldTransactionsAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const soldTransactions = ctx.spy(position.soldTransactions)
        return acc.plus(soldTransactions)
      }),
    )
  })

  const remainingSizeCurrencyAtom = reatomBigNumberComputed((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const sizeCurrency = ctx.spy(position.remainingSizeCurrency)
        return acc.plus(sizeCurrency)
      }),
    )
  })
  const remainingSizeUsdAtom = atom((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const sizeUsd = ctx.spy(position.remainingSizeUsd)
        return acc.plus(sizeUsd)
      }),
    )
  })
  const remainingSizeNativeAtom = atom((ctx) => {
    const walletPositions = ctx.spy(walletPositionsAtom)
    return pipe(
      walletPositions,
      Iterable.reduce(BigNumber(0), (acc, position) => {
        const sizeNative = ctx.spy(position.remainingSizeNative)
        return acc.plus(sizeNative)
      }),
    )
  })

  return {
    boughtSizeUsd: boughtSizeUsdAtom,
    boughtSizeNative: boughtSizeNativeAtom,
    boughtSizeCurrency: boughtSizeCurrencyAtom,
    boughtTransactions: boughtTransactionsAtom,

    soldSizeUsd: soldSizeUsdAtom,
    soldSizeNative: soldSizeNativeAtom,
    soldSizeCurrency: soldSizeCurrencyAtom,
    soldTransactions: soldTransactionsAtom,

    remainingSizeCurrency: remainingSizeCurrencyAtom,
    remainingSizeUsd: remainingSizeUsdAtom,
    remainingSizeNative: remainingSizeNativeAtom,
  }
}
